import { memo } from 'react';
import { Link } from '@compat/router';
import { Picture } from '@ui';
// import icons from '@icons';
// import useWindowSize from '@customHooks/useWindowSize';
import './index.scss';
import clsx from 'clsx';

// const {
//   chevronDown: { midGrey: chevronDownMGOutlined },
// } = icons.Outline;

// const { award: { midYellow: awardMYFilled } } = icons.Fill;

const headerNav = [
  { id: 0, title: 'Доставка и оплата', href: '/delivery', isYellow: false },
  { id: 1, title: 'Отзывы', href: '/reviews', isYellow: false },
  { id: 2, title: 'Рецепты', href: '/cook', isYellow: false },
  { id: 3, title: 'Бизнесу', href: '/opt', isYellow: false },
  {
    id: 4,
    title: 'Устричные бары',
    href: '/ustrichnye-bary-v-moskve',
    isYellow: true
  }
  // { id: 4, title: 'О нас', href: '/about' },
  // { id: 5, title: 'Легкий возврат', href: '/warranty', icon: awardMYFilled }
];

const ListItem = ({ icon, href, title, onClick, isYellow }) => (
  <li>
    <Link
      onClick={onClick}
      className={clsx(
        icon && 'header-nav__wrapper',
        isYellow && 'header-nav__wrapper--yellow'
      )}
      to={href}
    >
      {icon && (
        <Picture
          className='header-nav__icon'
          icon={icon}
          height='20'
          width='20'
        />
      )}
      {title}
    </Link>
  </li>
);

const HeaderNav = () => (
  <nav className='header-nav'>
    <ul className='header-nav__list'>
      {headerNav?.map(item => (
        <ListItem
          key={item.id}
          icon={item.icon}
          href={item.href}
          title={item.title}
          isYellow={item.isYellow}
        />
      ))}
    </ul>
  </nav>
);
export default memo(HeaderNav);
